import styled from "styled-components";
import breakpoints from "../../../styles/breakpoints";
import colors from "../../../styles/colors";
import fonts from "../../../styles/fonts";

const sideMenuWidth = "30rem";

export const SideMenuContainer = styled.div`
  display: ${(props: { expanded: boolean }) => (props.expanded ? "flex" : "none")};
  position: fixed;
  top: 5rem;
  left: 0;
  bottom: 0;
  width: ${sideMenuWidth};
  z-index: 5;
  flex-direction: column;
  color: ${colors.white};
  background: ${colors.menuBlueDark};
  font-family: ${fonts.OpenSans};
  transition: width 500ms;
  overflow: hidden;
  @media (${breakpoints.min800}) {
    display: flex;
    position: fixed;
    top: 7rem;
    z-index: 5;
    height: calc(100vh - 7rem);
  }

  a {
    align-items: center;
    color: white;
    display: flex;
    flex-direction: row;
    text-decoration: none;
    min-height: 3rem;
    padding: 0.5rem 1rem;
    border-bottom: 0.1rem solid ${colors.menuGreyBorder};
    overflow: hidden;
    :hover {
      background: ${colors.black};
    }

    svg {
      margin-right: 2rem;
    }
  }

  .selected {
    background: ${colors.menuBlueLight};
  }

  .separator {
    padding: 0rem 1.5rem;
    background: ${colors.menuBlueSolidDark};
    font-weight: bold;
  }
  .separator-hidden {
    height: 0;
  }
  &.collapsed {
    width: 5.5rem;
    overflow: hidden;
    transition: width 500ms;
  }
`;

export const SideMenuTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: ${sideMenuWidth};
`;

export const ObjectAmountContainer = styled.span`
  border: 0.1rem solid ${colors.white};
  box-sizing: border-box;
  border-radius: 0.5rem;
  margin-left: auto;
  margin-right: 0;
  cursor: pointer;
  color: ${colors.white};
  padding: 0.3rem 0.5rem;
  display: flex;
`;

export const Divider = styled.hr`
  display: flex;
  height: 0.1rem;
  width: 100%;
  background: ${colors.black};
  border: none;
`;

export const OrgLabel = styled.div`
  align-items: center;
  flex-direction: row;
  height: 3rem;
  padding: 0.6rem 1rem;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.menuGreyBorder};
`;

export const LinkWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  overflow: hidden;
  /* stylelint-disable  no-descending-specificity */
  svg {
    margin: 0rem 2rem 0rem 0.8rem;
    height: ${(props: { heightSVG?: string }) => props.heightSVG ?? "2.8rem"};
    width: 2rem;
  }
`;
